import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import AppLayout from "../layout/AppLayout";

export default function PrazosAdmin() {
  const [prazos, setPrazos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/prazos_list.php")
      .then(res => setPrazos(res.data))
      .catch(() => setPrazos([]));
  }, []);

  return (
    <AppLayout title="Agenda de Prazos">
      <div className="space-y-3">
        {prazos.map(p => (
          <div
            key={p.id}
            onClick={() => navigate(`/app/admin/processos/${p.processo_id}`)}
            className="cursor-pointer rounded-xl border border-[#1f2937] bg-[#121826] p-4 hover:bg-[#1a2233]"
          >
            <p className="text-sm text-slate-100">{p.descricao}</p>
            <p className="text-xs text-slate-400">
              {p.cliente} • {new Date(p.data_prazo).toLocaleDateString()}
            </p>
          </div>
        ))}
      </div>
    </AppLayout>
  );
}
